export const TRAINER_ONLINE_ONLY_PATTERNS = [
  /^\/auth\/login$/,
  /^\/auth\/invite$/,
  /^\/ai\//,
];

export {
  TEMP_ID_PREFIX,
  ENTITY_TABLES,
  COMPOSITE_KEYS,
} from '@coachapp/offline-core';
